import { render } from "./LiveSection.vue?vue&type=template&id=73f134b6&scoped=true"
import script from "./LiveSection.vue?vue&type=script&lang=js"
export * from "./LiveSection.vue?vue&type=script&lang=js"

import "./LiveSection.vue?vue&type=style&index=0&id=73f134b6&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f134b6"]])

export default __exports__